export default {
  'exception-403.exception.back': '返回首頁',
  'exception-403.description.403': '抱歉，妳無權訪問該頁面',
};
